'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import s from "../../external/classnames/index.js";
import { useTheme as h } from "../Provider/index.js";
const b = ({
  value: l,
  className: t,
  size: i = "medium",
  showPercentage: n = !1,
  "aria-label": o
}) => {
  const { isMoshy: r } = h(), a = Math.min(100, Math.max(0, l)), u = () => {
    switch (i) {
      case "small":
        return "h-1";
      case "medium":
        return "h-[6px]";
      case "large":
        return "h-2";
      default:
        return "h-[6px]";
    }
  }, c = () => r ? "bg-blue-extra-light" : "bg-sand-light", d = () => r ? "bg-blue-dark" : "bg-green-dark", m = s(
    "relative flex-1 rounded-[32px] overflow-hidden transition-all duration-200 ease-in-out",
    u(),
    c(),
    t
  ), x = s(
    "h-full rounded-[inherit] transition-all duration-300 ease-in-out relative",
    d()
  );
  return /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-2 w-full", children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-3 w-full", children: [
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: m,
        role: "progressbar",
        "aria-valuenow": a,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": o || `Progress: ${a}%`,
        children: /* @__PURE__ */ e.jsx(
          "div",
          {
            className: x,
            style: { width: `${a}%` }
          }
        )
      }
    ),
    n && /* @__PURE__ */ e.jsxs("span", { className: "text-xs font-semibold text-grey-400 whitespace-nowrap min-w-[30px]", children: [
      Math.round(a),
      "%"
    ] })
  ] }) });
};
export {
  b as default
};
